import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  site: {
    title: "Welcome to Ravent",

    logo: {
      src: { light: "/ravent-logo-color.png", dark: "/ravent-logo.png" },
      alt: "RAVENT",
      width: "130px",
    },
  },
  navigation: [
    {
      type: "category",
      label: "Documentation",
      items: [
        {
          type: "category",
          label: "Getting Started",
          icon: "sparkles",
          items: [
            "/introduction",
            {
              type: "link",
              icon: "folder-cog",
              label: "Orders API",
              to: "/api/orders",
            },
            {
              type: "link",
              icon: "lock",
              label: "Auth API",
              to: "/api/auth",
            },
          ],
        },
        {
          type: "category",
          label: "Useful Links",
          collapsible: false,
          icon: "link",
          items: [
            {
              type: "link",
              icon: "book",
              label: "Zudoku Docs",
              to: "https://zudoku.dev/docs/",
            },
          ],
        },
      ],
    },
    {
      type: "link",
      to: "/api/orders",
      label: "Orders API",
    },
    {
      type: "link",
      to: "/api/auth",
      label: "Auth API",
    },
  ],
  redirects: [{ from: "/", to: "/introduction" }],
  apis: [
    {
      type: "file",
      input: "./apis/orders-openapi.json",
      path: "/api/orders",
    },
    {
      type: "file",
      input: "./apis/auth-openapi.json",
      path: "/api/auth",
    },
  ],
};

export default config;
